// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"GdgWggWr","tooltipWrapper":"E8zHpqZ0","rightWrapper":"bsHFVMs3","titleLabel":"pd1yDy1J","categoryLabel":"iAbds2Xx"};